const CopyRight = () => {

  return(
    <div className="text-center">
      Copyright &copy; SysLab Technologies 2024
    </div>
  );

};

export default CopyRight;